export enum SectionTab {
  ORDERS = 'orders',
  INPUT_SETTINGS = 'input-settings',
}
